<template>
	<div style="height: calc(100vh - 135px);overflow: auto;padding-right:8px;overflow-x: hidden;">
		<!-- <div class="page_header" > -->
		<div style="display: flex; align-items: center; margin-top: 25px">
			<div style="flex: 1">
				<!-- <div class="page_title">{{ $t('alarm.page_title') }}</div> -->
				<!-- <span class="page_title">{{ $t("alarm.page_title") }}</span> -->
				<span class="page_title">{{$t('巡检.车辆巡检')}}</span>
				<span v-show="noteShow" style="font-size: 12px; color: #ff8c00; margin-left: 16px">
					<i class="iconfont icon-icon_prompt2" style="font-size: 16px; margin-right: 4px"></i>
					{{ $t("alarm.page_alarm") }}
				</span>
				<el-tooltip class="item" effect="light" :content="$t('alarm.page_alarm')" placement="top-start"
					v-show="!noteShow">
					<span style="font-size: 12px; color: #ff8c00; margin-left: 16px">
						<i class="iconfont icon-icon_prompt2" style="font-size: 16px; margin-right: 4px"></i>
					</span>
				</el-tooltip>
			</div>
			<div>
				<quickQuery :key="todayEnd.getTime()" :speedShow="false" :isNow="true" @handleQuery="handleQuery"
					@quickQuery="quickQuery" :searchTimeTemp="searchTime" :handleQueryData="todayEnd"
					:downloading="downloading" @download="download" style="flex: 1; text-align: right" />
			</div>
		</div>
		<div class="alarmSta">
			<el-row :gutter="20">
				<el-col :span="12">
					<div class="alarmStaRow">
						<div>{{$t('巡检.智能巡检')}}</div>
						<div style="display: flex;flex-direction: row;">
							<PieChart ref="pie1" :title="$t('龙翼简报.车辆总数')" :pieData="inspectpie"
								:totalSuffix="$t('public.cars')" :labelData="inspectpiecolor"
								:pieColors="['#1461E1', '#09B2F3']" />
							<PieChart ref="pie2" :title="$t('巡检.智能巡检车辆')" :pieData="inspectpiedata"
								:totalSuffix="$t('public.cars')" :labelData="inspectpiecolordata"
								:pieColors="['#FF106E', '#07B477']" />
						</div>
					</div>
				</el-col>
				<el-col :span="12">
					<div class="alarmStaRow">
						<div>{{$t('巡检.外观巡检')}}</div>
						<div style="display: flex;flex-direction: row;">
							<PieChart ref="pie3" :title="$t('龙翼简报.车辆总数')" :pieData="apperancedata"
								:labelData="apperanceColordata" :totalSuffix="$t('public.cars')"
								:pieColors="['#1461E1', '#09B2F3']" />
							<PieChart ref="pie4" :title="$t('巡检.外观巡检车辆')" :pieData="apperanceCardata"
								:labelData="apperanceCarColordata" :totalSuffix="$t('public.cars')"
								:pieColors="['#FF106E', '#07B477']" />
						</div>

					</div>
				</el-col>

			</el-row>
		</div>
		<div class="alarmlist">
			<el-table v-loading="loading" :size="size" :data="inspectData" border style="width: 100%" id="Data">


				<!-- 	<el-table-column prop="date" :label="date" align="center"></el-table-column> -->

				<el-table-column prop="CarNo" :label="carno" align="center"></el-table-column>
				<el-table-column prop="duration" :label="$t('巡检.巡检类型')" align="center">
					<template slot-scope="scope">
						<span class="inspection-type">
							{{ scope.row.InspectionType === 0 ? $t('巡检.智能巡检') : $t('巡检.外观巡检') }}
						</span>
					</template>
				</el-table-column>

				<el-table-column prop="InspectionTime" :label="$t('巡检.巡检时间')" align="center"></el-table-column>
				<el-table-column prop="OPTName" :label="$t('巡检.巡检人')" align="center"></el-table-column>
				<el-table-column prop="Result" :label="$t('巡检.巡检结果')" align="center">
					<template slot-scope="scope">
						<span :class="['status-badge', scope.row.Result === 0 ? 'status-normal' : 'status-abnormal']">
							{{ scope.row.Result === 0 ? $t('vehicletrack.normal') : $t('巡检.异常') }}
						</span>
					</template>
				</el-table-column>
				<el-table-column fixed="right" :label="$t('public.Operation')" width="100">
					<template slot-scope="scope">
						<el-button @click="handleClick(scope.row)" type="text"
							size="small">{{$t('public.Detail')}}</el-button>

					</template>
				</el-table-column>
			</el-table>
			<!-- 			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="totalCount"
				style="margin-top: 20px;"></el-pagination> -->
			<div style="margin-top: 15px; text-align: right;">
				<div style="text-align: right; margin-top:8px" class="pagination" v-show="totalCount>0">
					<el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage"
						:page-size="pageSize" layout="total, prev, pager, next" :total="totalCount" />
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		mapState
	} from 'vuex';
	import * as XLSX from "xlsx";
	import FileSaver from "file-saver";
	import quickQuery from "../../statistics/components/generalOrQuickQuery.vue";
	import {
		exportJsonToExcel
	} from "../../../utils/Export2Excel.js";
	import PieChart from "../vehicleInspection/inspectionSetting/components/PieChart.vue";
	// import * as echarts from "echarts";
	export default {
		name: "vehicleinspection",
		components: {
			quickQuery,
			PieChart
			// htmlToExcel
		},

		data() {
			return {
				downloading: false,
				loading: false,
				loading2: false,
				form: {},
				showBtn: undefined, //按钮默认选中：今天
				noteShow: false,
				inspectData: [],
				detailData: [],
				screenWidth: document.body.clientWidth,
				todayEnd: new Date(new Date().setHours(23, 59, 59, 999)),
				// searchTime: [
				// 	this.moment(
				// 		new Date(new Date().getTime() - 3600 * 1000 * 24 * 7)
				// 	).format("YYYY-MM-DD"),
				// 	this.moment(new Date()).format("YYYY-MM-DD"),
				// ],
				searchType: 1,
				alarmType: this.$t("alarm.alarmType"),
				date: this.$t("public.date"),
				carno: this.$t("failure.vehicle"),
				duration: this.$t("inspection.operating_duration"),
				departure: this.$t("inspection.departure_inspection"), //发车巡检
				export2: this.$t("alarm.export"),
				totalCount: 0, // 新增：用于显示总计
				currentPage: 1, // 当前页
				pageSize: 10, // 页大小
				inspectpie: [],
				inspectpiecolor: [],
				inspectpiedata: [],
				inspectpiecolordata: [],
				apperancedata: [],
				apperanceColordata: [],
				apperanceCardata: [],
				apperanceCarColordata: [],
				searchTime: [
					new Date(Date.now() - 6 * 24 * 60 * 60 * 1000), // 开始日期：今天 - 6天
					new Date(Date.now()) // 结束日期：今天（当前时间）
				],
			};
		},
		mounted() {
			const that = this;
			window.onresize = () =>
				(() => {
					window.screenWidth = document.body.clientWidth;
					that.screenWidth = window.screenWidth;
				})();
		},
		computed: {
			...mapState({
				opened: state => state.app.sidebar.opened,
				selectedVehicles: state => state.app.vehicles.selectedVehicles,
				operator: state => state.app.operator, // 直接映射操作人，避免重复获取
				savedInspectionQuery: state => state.app.inspectionQuery
			}),
			// 获取选中的车辆ID（复用逻辑）
			selectedVehicleIds() {
				const vehicleIds = this.selectedVehicles
					.filter(item => item.treeLevel === 5)
					.map(item => item.nodeValue);
				return vehicleIds.join(',') || '';
			},
			searchShow() {
				return this.searchType == 0 ? true : false;
			},
			size() {
				return this.$store.getters.size;
			},
			list() {
				return this.detailData;
			},
		},
		created() {
			// 页面初始化时，恢复上一次的查询状态
			if (this.savedInspectionQuery.searchTime.length > 0 && Object.keys(this.savedInspectionQuery.form).length >
				0) {
				// 恢复查询时间
				this.searchTime = [...this.savedInspectionQuery.searchTime];
				// 恢复查询条件（beginDate/endDate等）
				this.form = {
					...this.savedInspectionQuery.form
				};
			} else {
				// 无存储状态时，使用默认时间（7天内）
				this.searchTime = [
					new Date(Date.now() - 6 * 24 * 60 * 60 * 1000),
					new Date(Date.now())
				];
				// 初始化默认查询条件
				this.form = {
					beginDate: this.moment(this.searchTime[0]).format("YYYY-MM-DD"),
					endDate: this.moment(this.searchTime[1]).format("YYYY-MM-DD")
				};
			}
			// 初始化时执行查询
			this.getrecordData();
		},
		watch: {
			screenWidth(val) {
				if (!this.timer) {
					this.screenWidth = val;
					this.timer = true;
					const that = this;
					setTimeout(function() {
						if (that.screenWidth >= 1640) {
							that.noteShow = true;
						} else that.noteShow = false;
						that.timer = false;
						// 新增：缩放后刷新饼图
						that.refreshAllPies();
					}, 10);
				}
				deep: true;
			},
		},
		activated() {
			this.$nextTick(() => this.refreshAllPies());
		},
		methods: {
			refreshAllPies() {
				this.$refs.pie1?.refreshChart();
				this.$refs.pie2?.refreshChart();
				this.$refs.pie3?.refreshChart();
				this.$refs.pie4?.refreshChart();
			},
			// 处理每页显示数量变化
			handleSizeChange(val) {
				this.pageSize = val;
				this.getrecordData();
				// this.getData();
			},

			// 处理当前页码变化
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getrecordData();
				// this.getData();
			},
			handleClick(row) {
				console.log(row)
				this.$router.push({
					path: "/inspectiondetail",
					query: {
						inspectionData: JSON.stringify(row) // 将对象转为JSON字符串传递
					}
				});
			},

			download() {
				var that = this;
				if (that.inspectData.length === 0) {
					that.$message.error(that.$t("statistics.PleQuery"));
					return;
				}
				that.loading = true; // 开始加载
				that.downloading = true;
				that.$api
					.downqueryInspectionRecordWeb({
						OperatorID: this.$store.getters.operator.OperatorId.toString(),
						VehicleIDs: this.selectedVehicleIds,
						BeginDate: this.form.beginDate,
						EndDate: this.form.endDate,
						InspectionType: -1,
						IsExport: 1,
					})
					.then((res) => {
						const blob = new Blob([res], {
							type: "application/vnd.ms-excel;charset=utf-8"
						});
						const a = document.createElement("a");
						a.href = window.URL.createObjectURL(blob);
						a.setAttribute(
							"download",
							`${this.$t('巡检.车辆巡检')} ${this.$t('public.download')}_${that.timestampToTime(new Date().getTime())}.xlsx`
						);
						a.click(); // 触发下载
						window.URL.revokeObjectURL(blob); // 释放内存
						that.downloading = false;
					})
					.catch((error) => {
						that.downloading = false;
						console.error(this.$t('巡检.下载失败'), error);
					})
					.finally(() => {
						that.loading = false; // 无论成功或失败，最终关闭加载状态
					});
			},

			handleQuery(val) {
				this.form = val;
				delete this.form.pageNum;
				delete this.form.pageSize;
				// 保存查询状态到Vuex（关键）
				this.$store.dispatch('app/setInspectionQuery', {
					form: {
						...this.form
					},
					searchTime: [...this.searchTime]
				});
				this.getrecordData();
			},
			quickQuery(val) {
				this.form = val;
				delete this.form.pageNum;
				delete this.form.pageSize;
				// 同步更新searchTime（根据快捷查询结果）
				this.searchTime = [
					this.moment(val.beginDate).toDate(),
					this.moment(val.endDate).toDate()
				];
				// 保存查询状态到Vuex（关键）
				this.$store.dispatch('app/setInspectionQuery', {
					form: {
						...this.form
					},
					searchTime: [...this.searchTime]
				});
				this.getrecordData();
			},
			//时间戳转换为日期格式
			timestampToTime(timestamp) {
				var date = new Date(timestamp); //时间数为10位篇*1000，时间数为13位的话不需乘1000
				var Y = date.getFullYear();
				var M =
					date.getMonth() + 1 < 10 ?
					"0" + (date.getMonth() + 1) :
					date.getMonth() + 1;
				var D = date.getDate();
				var h = date.getHours();
				var m = date.getMinutes();
				var s = date.getSeconds();
				return Y + M + D + h + m + s;
			},
			getrecordData() {
				this.$api.queryInspectionRecordWeb({
					OperatorID: this.$store.getters.operator.OperatorId.toString(),
					VehicleIDs: this.selectedVehicleIds,
					BeginDate: this.form.beginDate,
					EndDate: this.form.endDate,
					InspectionType: -1, //（0 智能巡检 1 外观巡检 -1 查全部）           
					IsExport: 0, //1为下载 0 为查询
					PageNo: this.currentPage,
					PageSize: this.pageSize,
				}).then((res) => {
					console.log(res);
					// 使用接口返回的countdata对象更新inspectpie的值
					if (res && res.countdata) {
						this.inspectData = res.data.map(item => {
							let processedTime = '';
							if (item.InspectionTime) {
								processedTime = item.InspectionTime
									.replace('T', ' ')
									.split('.')[0]
									.replace('Z', '');
							}
							return {
								...item,
								InspectionTime: processedTime
							};
						});
						this.totalCount = res.count;
						const {
							AutoCount,
							VehicleCount,
							AutoFail,
							ExCount,
							ExFail
						} = res.countdata;
						var noinspct = VehicleCount - AutoCount; //未巡检个数
						var nornalinspct = AutoCount - AutoFail; //正常巡检
						this.inspectpie = [{
								name: this.$t('巡检.已巡检'),
								value: AutoCount
							},
							{
								name: this.$t('巡检.未巡检'),
								value: noinspct
							}
						];
						this.inspectpiecolor = [{
								color: '#1461E1',
								text: this.$t('巡检.已巡检') + AutoCount.toString()
							},
							{
								color: '#09B2F3',
								text: this.$t('巡检.未巡检') + noinspct.toString()
							}
						];
						this.inspectpiedata = [{
								name: this.$t('巡检.异常'),
								value: AutoFail
							},
							{
								name: this.$t('vehicletrack.normal'),
								value: nornalinspct
							}
						];

						this.inspectpiecolordata = [{
								color: '#FF106E ',
								text: this.$t('巡检.异常') + AutoFail.toString()
							},
							{
								color: '#07B477',
								text: this.$t('vehicletrack.normal') + nornalinspct.toString()
							}
						];
						var noapperance = res.countdata.VehicleCount - res.countdata.ExCount; //未巡检个数
						this.apperancedata = [{
								name: this.$t('巡检.已巡检'),
								value: res.countdata.ExCount
							},
							{
								name: this.$t('巡检.未巡检'),
								value: noapperance
							}
						];
						this.apperanceColordata = [{
								color: '#1461E1',
								text: this.$t('巡检.已巡检') + res.countdata.ExCount
							},
							{
								color: '#09B2F3',
								text: this.$t('巡检.未巡检') + noapperance.toString()
							}
						];
						var apperancenomal = res.countdata.ExCount - res.countdata.ExFail
						this.apperanceCardata = [{
								name: this.$t('巡检.异常'),
								value: res.countdata.ExFail
							},
							{
								name: this.$t('vehicletrack.normal'),
								value: apperancenomal
							}
						];
						this.apperanceCarColordata = [{
								color: '#FF106E',
								text: this.$t('巡检.异常') + res.countdata.ExFail
							},
							{
								color: '#07B477',
								text: this.$t('vehicletrack.normal') + apperancenomal.toString()
							}
						];
						this.$nextTick(() => this.refreshAllPies());
					} else {
						this.inspectData = [];
						// 如果接口没有返回countdata，使用默认值
						// this.inspectpie = [
						//   { name: '已巡检', value: 18 },
						//   { name: '未巡检', value: 7 }
						// ];
					}
				}).catch(error => {
					console.error(this.$t('巡检.获取巡检记录失败'), error);
					// 出错时使用默认值
					// this.inspectpie = [
					//   { name: '已巡检', value: 18 },
					//   { name: '未巡检', value: 7 }
					// ];
				});
			},

			// getData() {
			// 	this.loading = true;
			// 	this.$api
			// 		.queryInspectionRecord({
			// 			VehicleID: this.selectedVehicleIds,
			// 			pageNo: this.currentPage,
			// 			pageSize: this.pageSize,
			// 			BeginDate: this.form.beginDate,
			// 			EndDate: this.form.endDate,
			// 		})
			// 		.then((res) => {
			// 			this.loading = false;
			// 			console.log(res)
			// 			if (res.recordsTotal > 0 && res.data != null) {
			// 				this.inspectData = res.data;
			// 				this.totalCount = res.datacount;
			// 			} else {
			// 				this.inspectData = [];
			// 			}
			// 		})
			// 		.catch(() => {
			// 			this.loading = false;
			// 		});
			// },

			clickFlag(row) {
				if (row.alarmNum > 0) {
					return true;
				} else return false;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.form {
		::v-deep .el-form-item {
			margin-bottom: 0px !important;
			margin-right: 0px !important;
		}

		::v-deep .el-form-item__label {
			font-size: 12px;
		}
	}

	::v-deep {
		.el-date-editor .el-range-separator {
			width: 18% !important;
		}

	}

	.alarmlist {
		margin-top: 20px;

		::v-deep .el-table tr {
			background: transparent;
		}

		::v-deep.el-table {
			background: transparent;
		}

		::v-deep .el-table td {
			background: transparent;
		}
	}

	.time {
		margin-left: 5px;
		// width:53px;
		text-align: center;
	}

	.el-dialog {
		display: flex;
		flex-direction: column;
		margin: 0 !important;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		/*height:600px;*/
		max-height: calc(100% - 200px);
		max-width: calc(100% - 30px);
	}

	.el-dialog .el-dialog__body {
		flex: 1;
		overflow: auto;
	}

	.alarmSta {
		margin-top: 30px;
	}

	.alarmStaRow {
		height: 280px;
		background: #E8F0FF;
		border: 1px solid #C5D0E2;
		font-weight: 600;
		font-size: 14px;
		color: #0E193B;
		padding: 20px;
	}

	.tag {
		width: 32px;
		height: 16px;
		// background: #1461E1;
		border-radius: 2px;
		margin-right: 12px
	}

	.tagText {
		font-weight: 400;
		font-size: 14px;
		color: #0E193B;
		text-align: left;
	}

	.chartsLabel {
		flex: 1;
		display: flex;
		flex-direction: row;
		justify-content: center;
		// margin-left: 16px;
	}

	::v-deep #barChart {
		width: 100% !important;
		height: 220px !important;
		/* 强制生效 */
	}

	.status-normal {
		background-color: #f0f9eb;
		color: #07B477;
	}

	.status-abnormal {
		background-color: #fef0f0;
		color: #FF106E;
	}
</style>